import { isRiskIqEnabled } from '@utils-clean/feature-flags';

// RiskIQ routes are behind a runtime UI feature flag (see public/settings/riskIqEnabled.js).
// Their paths stay in paths.tsx; a disabled route is simply not registered, so a direct URL
// falls through to the router's normal not-found/redirect behaviour.
export const riskIqRouteKeys = ['protocol-insights-risk-iq-review', 'protocol-insights-risk-iq-history'];

export const filterFeatureFlaggedRoutes = <TRoute extends { key: string }>(routes: TRoute[]): TRoute[] =>
    isRiskIqEnabled() ? routes : routes.filter((route) => !riskIqRouteKeys.includes(route.key));
